import { CreateSellyRtcEngine } from './dist/sellycloudwebsdk.es.js';

const $ = (id) => document.getElementById(id);
const logEl = $('log');
const playerEl = $('player');
const previewEl = $('preview');

let client;
let manualPlayPending = false;
const DEFAULT_APP = 'live';
let appName = DEFAULT_APP;
let currentZlm = null; // 保存推流成功后返回的 zlm 地址
let currentLang = (typeof localStorage !== 'undefined' && localStorage.getItem('lang')) || 'zh';

const i18n = {
  zh: {
    brandTitle: 'sellycloud Live Studio',
    heroEyebrow: '实时互动',
    heroTitle: '推 / 拉流全链路',
    heroLead: '一键预览、推流、拉流',
    pushEyebrow: '推流',
    pushTitle: '主播',
    playEyebrow: '拉流',
    playTitle: '观众',
    btnPreview: '开始预览',
    btnStopPreview: '停止预览',
    btnStartPush: '开始推流',
    btnStopPush: '停止推流',
    btnManualPlay: '开始拉流',
    btnStopPlay: '停止拉流',
    labelPushChannelId: '频道ID',
    labelPushProto: 'UDP / TCP',
    labelPlayServer: '服务器',
    labelPlayChannelId: '频道ID',
    labelPlayProto: 'UDP / TCP',
    labelZlmServer: '服务器地址',
    optUdp: '0（默认 UDP 优先）',
    optTcp: '1（TCP 优先）',
    cameraFallback: '摄像头 {id}',
    micFallback: '麦克风 {id}',
    fillStream: '请填写频道ID',
    previewFail: '预览失败: {err}',
    pushError: '推流错误: {err}',
    pushFail: '推流失败: {err}',
    manualPlayFail: '拉流失败: {err}',
    playConnected: '拉流已连接',
    autoPlayFail: '自动播放失败: {err}',
    playStartFail: '播放启动失败: {err}',
    deviceError: '枚举设备失败: {err}',
    devicesFound: '检测到设备：摄像头 {cams} 个，麦克风 {mics} 个',
    copySuccess: '已复制链接',
    copyFail: '复制失败: {err}',
    warnInsecure: '警告：当前页面不是安全上下文（HTTPS 或 localhost），可能导致摄像头/麦克风被阻止。',
    langToggle: 'English',
    logEyebrow: '日志',
    logTitle: '实时日志',
    btnToggleDebug: 'Debug',
    btnToggleDebugHide: '关闭 Debug',
    btnCloseLog: '关闭',
    labelShareUrl: '分享链接',
    shareUrlGenerated: '分享链接已生成: {url}',
    shareUrlCopied: '分享链接已复制: {url}',
  },
  en: {
    brandTitle: 'sellycloud Live Studio',
    heroEyebrow: 'Live Interaction',
    heroTitle: 'Publish / Play on one page',
    heroLead: 'Preview, publish, and play with one click.',
    pushEyebrow: 'Publish',
    pushTitle: 'Streamer',
    playEyebrow: 'Play',
    playTitle: 'Audience',
    btnPreview: 'Start Preview',
    btnStopPreview: 'Stop Preview',
    btnStartPush: 'Start Publish',
    btnStopPush: 'Stop Publish',
    btnManualPlay: 'Start Play',
    btnStopPlay: 'Stop Play',
    labelPushChannelId: 'Channel ID',
    labelPushProto: 'UDP / TCP',
    labelPlayServer: 'Server',
    labelPlayChannelId: 'Channel ID',
    labelPlayProto: 'UDP / TCP',
    labelZlmServer: 'Server Address',
    optUdp: '0 (UDP preferred)',
    optTcp: '1 (TCP preferred)',
    cameraFallback: 'Camera {id}',
    micFallback: 'Mic {id}',
    fillStream: 'Please enter Channel ID',
    previewFail: 'Preview failed: {err}',
    pushError: 'Publish error: {err}',
    pushFail: 'Publish failed: {err}',
    manualPlayFail: 'Play failed: {err}',
    playConnected: 'Play connected',
    autoPlayFail: 'Autoplay failed: {err}',
    playStartFail: 'Play start failed: {err}',
    deviceError: 'Enumerate devices failed: {err}',
    devicesFound: 'Devices: cameras {cams}, mics {mics}',
    copySuccess: 'Link copied',
    copyFail: 'Copy failed: {err}',
    warnInsecure: 'Warning: not a secure context (HTTPS or localhost), camera/mic may be blocked.',
    langToggle: '中文',
    logEyebrow: 'Log',
    logTitle: 'Live Log',
    btnToggleDebug: 'Debug',
    btnToggleDebugHide: 'Hide Debug',
    btnCloseLog: 'Close',
    labelShareUrl: 'Share Link',
    shareUrlGenerated: 'Share link generated: {url}',
    shareUrlCopied: 'Share link copied: {url}',
  },
};

function t(key, params = {}) {
  const str = (i18n[currentLang] && i18n[currentLang][key]) || key;
  return Object.entries(params).reduce((acc, [k, v]) => acc.replace(`{${k}}`, v), str);
}

function applyLang() {
  const setText = (id, key) => { const el = $(id); if (el) el.textContent = t(key); };
  setText('brandTitle', 'brandTitle');
  setText('heroEyebrow', 'heroEyebrow');
  setText('heroTitle', 'heroTitle');
  setText('heroLead', 'heroLead');
  setText('pushEyebrow', 'pushEyebrow');
  setText('pushTitle', 'pushTitle');
  setText('playEyebrow', 'playEyebrow');
  setText('playTitle', 'playTitle');
  setText('btnPreview', 'btnPreview');
  setText('btnStopPreview', 'btnStopPreview');
  setText('btnStartPush', 'btnStartPush');
  setText('btnStopPush', 'btnStopPush');
  setText('btnManualPlay', 'btnManualPlay');
  setText('btnStopPlay', 'btnStopPlay');
  setText('labelPushChannelId', 'labelPushChannelId');
  setText('labelPushProto', 'labelPushProto');
  setText('labelPlayServer', 'labelPlayServer');
  setText('labelPlayChannelId', 'labelPlayChannelId');
  setText('labelPlayProto', 'labelPlayProto');
  setText('labelZlmServer', 'labelZlmServer');
  setText('logEyebrow', 'logEyebrow');
  setText('logTitle', 'logTitle');
  setText('btnCloseLog', 'btnCloseLog');
  setText('labelShareUrl', 'labelShareUrl');
  // Update debug toggle button based on current state
  const logSection = $('logSection');
  const btnToggleDebug = $('btnToggleDebug');
  if (btnToggleDebug) {
    const isDebugVisible = logSection && logSection.style.display !== 'none';
    btnToggleDebug.textContent = isDebugVisible ? t('btnToggleDebugHide') : t('btnToggleDebug');
  }
  const optsPush = $('pushPreferredTcp')?.options;
  if (optsPush) {
    optsPush[0].textContent = t('optUdp');
    optsPush[1].textContent = t('optTcp');
  }
  const optsPlay = $('playPreferredTcp')?.options;
  if (optsPlay) {
    optsPlay[0].textContent = t('optUdp');
    optsPlay[1].textContent = t('optTcp');
  }
  const langBtn = $('btnLang');
  if (langBtn) langBtn.textContent = t('langToggle');
}

function log(msg) {
  if (!logEl) return;
  const line = `${new Date().toLocaleTimeString()} - ${msg}`;
  logEl.textContent += `\n${line}`;
  logEl.scrollTop = logEl.scrollHeight;
}

function showToast(message, timeout = 1800) {
  const el = $('toast');
  if (!el) return;
  el.textContent = message;
  el.classList.add('show');
  if (el._timer) clearTimeout(el._timer);
  el._timer = setTimeout(() => el.classList.remove('show'), timeout);
}

function updateMetrics() {
  const streamVal = $('playStream')?.value || $('pushStream')?.value || '--';
  const setText = (id, text) => { const el = $(id); if (el) el.textContent = text || '--'; };
  setText('metricStream', streamVal);
}

async function ensureAutoPlay() {
  if (!playerEl) return;
  playerEl.muted = true;
  try {
    await playerEl.play();
  } catch (err) {
    if (err && (err.name === 'NotAllowedError' || err.name === 'DOMException')) {
      try { await playerEl.play(); } catch (e2) { log(t('autoPlayFail', { err: e2.message })); }
    } else {
      log(t('playStartFail', { err: err.message }));
    }
  }
}

async function fillDevices() {
  try {
    const { cameras, mics } = await client.getDevices();
    const camSel = $('cameraSel');
    const micSel = $('micSel');
    if (camSel) {
      camSel.innerHTML = '';
      cameras.forEach(d => {
        const opt = document.createElement('option');
        opt.value = d.deviceId;
        opt.textContent = d.label || t('cameraFallback', { id: d.deviceId.slice(0, 6) });
        camSel.appendChild(opt);
      });
    }
    if (micSel) {
      micSel.innerHTML = '';
      mics.forEach(d => {
        const opt = document.createElement('option');
        opt.value = d.deviceId;
        opt.textContent = d.label || t('micFallback', { id: d.deviceId.slice(0, 6) });
        micSel.appendChild(opt);
      });
    }
    log(t('devicesFound', { cams: cameras.length, mics: mics.length }));
  } catch (err) {
    log(t('deviceError', { err: err.message }));
  }
}

function bindEvents() {
  $('btnToggleDebug')?.addEventListener('click', () => {
    const logSection = $('logSection');
    const debugFields = document.querySelectorAll('.debug-field');
    const pushStream = $('pushStream');
    const playStream = $('playStream');
    if (logSection) {
      const isHidden = logSection.style.display === 'none';
      logSection.style.display = isHidden ? 'block' : 'none';
      debugFields.forEach(field => field.style.display = isHidden ? 'block' : 'none');
      // Make Channel ID inputs editable in debug mode
      if (pushStream) pushStream.readOnly = !isHidden;
      if (playStream) playStream.readOnly = !isHidden;
      $('btnToggleDebug').textContent = isHidden ? t('btnToggleDebugHide') : t('btnToggleDebug');
    }
  });

  $('btnCloseLog')?.addEventListener('click', () => {
    const logSection = $('logSection');
    const debugFields = document.querySelectorAll('.debug-field');
    const pushStream = $('pushStream');
    const playStream = $('playStream');
    if (logSection) {
      logSection.style.display = 'none';
      debugFields.forEach(field => field.style.display = 'none');
      // Make Channel ID inputs readonly when closing debug
      if (pushStream) pushStream.readOnly = true;
      if (playStream) playStream.readOnly = true;
      $('btnToggleDebug').textContent = t('btnToggleDebug');
    }
  });

  $('btnLang')?.addEventListener('click', () => {
    currentLang = currentLang === 'zh' ? 'en' : 'zh';
    if (typeof localStorage !== 'undefined') localStorage.setItem('lang', currentLang);
    applyLang();
  });

  $('btnPreview')?.addEventListener('click', async () => {
    try {
      const camId = $('cameraSel')?.value || '';
      const micId = $('micSel')?.value || '';
      await client.startPreview({ videoDeviceId: camId, audioDeviceId: micId });
      const btnPush = $('btnStartPush');
      if (btnPush) btnPush.disabled = false;
      // Show stop preview button, hide start preview button
      $('btnPreview').style.display = 'none';
      $('btnStopPreview').style.display = 'inline-block';
    } catch (err) {
      const msg = t('previewFail', { err: err.message });
      log(msg);
      showToast(msg, 2500);
    }
  });

  $('btnStopPreview')?.addEventListener('click', () => {
    client.stopPreview();
    // Clear preview video
    if (previewEl) previewEl.srcObject = null;
    // Show start preview button, hide stop preview button
    $('btnPreview').style.display = 'inline-block';
    $('btnStopPreview').style.display = 'none';
    // Disable push button since preview is stopped
    const btnPush = $('btnStartPush');
    if (btnPush) btnPush.disabled = true;
  });

  $('btnStartPush')?.addEventListener('click', async () => {
    const stream = $('pushStream').value.trim();
    const preferredTcp = $('pushPreferredTcp').value || '0';
    if (!stream) {
      showToast(t('fillStream'));
      return;
    }
    $('btnStartPush').disabled = true;
    try {
      await client.startPush({ app: appName, stream, preferredTcp, playRetry: 3 });
      $('btnStartPush').disabled = false;
    } catch (err) {
      log(t('pushError', { err: err.message }));
      showToast(t('pushFail', { err: err.message }), 2500);
      $('btnStartPush').disabled = false;
    }
  });

  $('btnStopPush')?.addEventListener('click', () => {
    client.stopPush();
  });

  $('btnManualPlay')?.addEventListener('click', async () => {
    const stream = $('playStream').value.trim();
    const zlm = $('playServer').value.trim();
    const preferredTcp = $('playPreferredTcp').value || '0';
    if (!stream) {
      showToast(t('fillStream'));
      return;
    }
    try {
      // 使用界面输入的 zlm 地址，若无则使用 SDK 默认地址
      await client.startPlay({ app: appName, stream, zlm: zlm || currentZlm, preferredTcp });
      manualPlayPending = true;
      const btn = $('btnManualPlay');
      if (btn) btn.disabled = true;
    } catch (err) {
      log(t('manualPlayFail', { err: err.message }));
      showToast(t('manualPlayFail', { err: err.message }), 2500);
      manualPlayPending = false;
      const btn = $('btnManualPlay');
      if (btn) btn.disabled = false;
    }
  });

  $('btnStopPlay')?.addEventListener('click', () => {
    client.stopPlay();
  });

  $('btnCopyShareUrl')?.addEventListener('click', async () => {
    const text = $('shareUrl')?.value?.trim();
    if (!text) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const tmp = document.createElement('textarea');
        tmp.value = text;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
      }
      showToast(t('copySuccess'));
      log(t('shareUrlCopied', { url: text }));
    } catch (err) {
      showToast(t('copyFail', { err: err.message }), 2500);
    }
  });

  ['pushStream', 'playStream'].forEach((id) => {
    const el = $(id);
    if (el) el.addEventListener('input', updateMetrics);
  });
}

function setDefaultStream() {
  const val = String(Date.now());
  $('pushStream').value = val;
  $('playStream').value = val;
  updateMetrics();
}

function wireClientEvents() {
  client.on('log', log);
  client.on('preview-stream', (stream) => { if (previewEl) previewEl.srcObject = stream; });
  client.on('play-stream', (stream) => {
    if (!playerEl || !stream) return;
    // 避免重复赋值导致 play 中断：仅当 srcObject 不同或没有 track 时才更新
    const hasTracks = (stream?.getTracks?.() || []).length > 0;
    if (playerEl.srcObject !== stream) {
      playerEl.srcObject = stream;
    }
    if (hasTracks) {
      ensureAutoPlay();
    }
  });
  client.on('push-ice', (state) => log('推流 ICE: ' + state));
  client.on('play-ice', (state) => log('拉流 ICE: ' + state));
  client.on('push-success', ({ app, stream, zlm, preferredTcp }) => {
    // 启用停止推流按钮
    const btnStopPush = $('btnStopPush');
    if (btnStopPush) btnStopPush.disabled = false;

    // 同步表单
    $('playStream').value = stream;
    $('playServer').value = zlm;
    $('playPreferredTcp').value = preferredTcp;
    appName = app || DEFAULT_APP;
    currentZlm = zlm; // 保存 zlm 地址供拉流使用
    updateMetrics();

    // 生成分享链接（包含 zlm 服务器地址）- 使用相对路径
    const basePath = location.pathname.substring(0, location.pathname.lastIndexOf('/') + 1);
    const shareUrl = `${location.origin}${basePath}player.html?app=${encodeURIComponent(app)}&stream=${encodeURIComponent(stream)}&zlm=${encodeURIComponent(zlm)}&preferred_tcp=${preferredTcp}`;
    const shareUrlField = $('shareUrlField');
    const shareUrlInput = $('shareUrl');
    if (shareUrlField && shareUrlInput) {
      shareUrlInput.value = shareUrl;
      shareUrlField.style.display = 'block';
      log(t('shareUrlGenerated', { url: shareUrl }));
    }
  });
  client.on('play-success', () => {
    // 拉流成功后，允许再次尝试停止/重播
    $('btnStopPlay').disabled = false;
    manualPlayPending = false;
    const btn = $('btnManualPlay');
    if (btn) btn.disabled = false;
  });
  client.on('play-stopped', () => { $('btnStopPlay').disabled = true; });
  client.on('push-stopped', () => {
    $('btnStartPush').disabled = false;
    $('btnStopPush').disabled = true;
  });
  client.on('play-ice', (state) => {
    log('拉流 ICE: ' + state);
    if (manualPlayPending && (state === 'connected' || state === 'completed')) {
      showToast(t('playConnected'));
      manualPlayPending = false;
      const btn = $('btnManualPlay');
      if (btn) btn.disabled = false;
    }
  });
}

function initFormFromQuery() {
  const params = new URLSearchParams(location.search);
  const app = params.get('app');
  const stream = params.get('stream');
  const zlm = params.get('zlm');
  const preferred = params.get('preferred_tcp');
  const autoplay = params.get('autoplay');
  if (app) {
    appName = app;
  } else {
    appName = DEFAULT_APP;
  }
  if (stream) {
    $('playStream').value = stream;
    $('pushStream').value = stream;
  }
  if (preferred) {
    $('playPreferredTcp').value = preferred;
    $('pushPreferredTcp').value = preferred;
  }
  updateMetrics();
}

document.addEventListener('DOMContentLoaded', () => {
  client = CreateSellyRtcEngine();
  wireClientEvents();
  applyLang();
  setDefaultStream();
  bindEvents();
  const btnPush = $('btnStartPush');
  if (btnPush) btnPush.disabled = false;
  fillDevices();
  initFormFromQuery();
  if (!window.isSecureContext) {
    log(t('warnInsecure'));
  }
});
